export function overrideAppBar(theme) {
  theme.props.MuiAppBar = {
    elevation: 0,
    color: 'inherit',
    position: 'static'
  };
}